import styled from 'styled-components'
import { themeObject, textModels } from 'Pages/landings/newLandings/common/style'
import { ListWithImg } from 'Pages/landings/newLandings/acquiring/ManageAccount/styled'

import { TooltipComponent as TooltipComponentMain } from 'Pages/landings/newLandings/common/components'

export const Title = styled.p`
	${textModels('heading', 'h2', '600')}
	color: ${themeObject.colors.grey[800]};
	margin-bottom: 24px;
`
export const ListWithImgWrapper = styled(ListWithImg)`
	max-height: 564px;
`

export const LinkDashed = styled.span`
	border-bottom: 1px dashed ${themeObject.colors.grey[600]};
	transition: color .6s linear, border-color .6s linear;
	&:hover {
		color: ${themeObject.colors.grey[700]};
		border-color: ${themeObject.colors.grey[700]};
`
export const Subtitle = styled.p`
	${textModels('notAdaptive', 'm', '400')}
	color: ${themeObject.colors.grey[600]};
`

export const TooltipComponent = styled(TooltipComponentMain)`
	width: 233px;
`
